export default {
  backup: 'Бэкап',
  logout: 'Выйти',
  login: 'Войти',
  save: 'Сохранить',
  set: 'Установить',
  save_all: 'Сохранить все',
  save_changes: 'Сохранить',
  cancel: 'Отмена',
  remove: 'Удалить',
  reset: 'Сбросить',
  reject: 'Отклонить',
  confirm: 'Подтвердить',
  apply: 'Применить',
  restore: 'Восстановить',
  action: 'Действие',
  add_model: 'Добавить модель',
  load: 'Загрузить',
  update: 'Обновить',
  acknowledge: 'Подтвердить',
  add: {
    title: 'Добавить',
    preprocessor: 'Добавить новый препроцессор',
    postprocessor: 'Добавить новый постпроцессор',
    server: 'Добавить сервер',
    list: 'Добавить список',
    member: 'Добавить элемент',
    stream: 'Добавить инпут',
    output: 'Добавить вывод',
    user: 'Добавить нового пользователя',
    filter: 'Добавить фильтр',
    toDashboard: 'Добавить на дашбоард',
    new: 'Добавить',
    noResultsFor: 'Нет результатов для',
    changeSource: 'Изменить источник',
    addToPipeline: 'Добавить к пайплайну'
  },
  upload: {
    title: 'Upload',
    zip: 'Загрузить .zip',
    file: 'Перетащите сюда свой {types} файл или нажмите, чтобы загрузить'
  },
  download: {
    log: 'Скачать лог-файлы'
  },
  delete: {
    log: 'Удалить логи'
  },
  draw: {
    title: 'Нарисовать',
    line: 'Линия',
    rectangle: 'Прямоугольник',
    polygon: 'Полигон'
  },
  list_type: 'Тип списка',
  list_last_update: 'Последнее обновление',
  'number of items': 'Количество элементов'
}
